import React from 'react';
import * as Unicons from '@iconscout/react-unicons';
import Card from '../../components/elements/Card';
import { Divider, Flex, NumberFormatter, Space, Text } from '@mantine/core';
import LabelDate from '../../components/fragments/LabelDate';
import { TbCircleLetterP } from 'react-icons/tb';
import ActionVoucherRedeem from './ActionVoucherRedeem';

const VoucherDetail = ({ dataDetail }) => {
  return (
    <Card>
      <Text fw="700">Voucher Detail</Text>
      <Divider my="lg" />
      <Flex align="center">
        <Unicons.UilCalender size={20} />
        <Space w="sm" />
        <Text size="sm" fw="700">
          Valid Until{' '}
          <Text span inherit>
            <LabelDate date={dataDetail?.endDate} />
          </Text>
        </Text>
      </Flex>
      <Flex align="center">
        <TbCircleLetterP size={20} color="orange" />
        <Space w="sm" />
        <NumberFormatter
          value={Number(dataDetail?.redeemPoint)}
          suffix={` Point${Number(dataDetail?.redeemPoint) > 1 ? 's' : ''}`}
          thousandSeparator="."
          decimalSeparator=","
        />
      </Flex>
      <Flex align="center" mb={12}>
        <Unicons.UilBox size={20} />
        <Space w="sm" />
        {Number(dataDetail?.availableStock) === 0 ? (
          <Text c={'red'}>Out of stock</Text>
        ) : (
          <NumberFormatter
            value={Number(dataDetail?.availableStock)}
            suffix=" left"
            thousandSeparator="."
            decimalSeparator=","
          />
        )}
      </Flex>
      <ActionVoucherRedeem dataDetail={dataDetail} />
    </Card>
  );
};

export default VoucherDetail;
